<template>
  <CustomerLedger :lead-mode="true" />
</template>

<script>
import CustomerLedger from "../customers/CustomerLedger.vue";

export default {
  name: "LeadLedger",
  components: {
    CustomerLedger
  }
};
</script>
